import { Component } from '@angular/core';

@Component({
  selector: 'my-compania',
  styles: [],
  templateUrl: 'compania.component.html'
})

export class CompaniaComponent {}


// WEBPACK FOOTER //
// ./src/app/compania/compania.component.ts